// eslint-disable-next-line no-unused-vars
import auth from "./firebaseConfig";
import {FacebookAuthProvider, GoogleAuthProvider} from "firebase/auth";

export const facebookProvider = new FacebookAuthProvider();
export const googleProvider = new GoogleAuthProvider();
